import styled from "styled-components";

import * as css from "styles/CssVariables.js";
import WalletDisplay from "./WalletDisplay";
import CashBonusDisplay from "./CashBonusDisplay";
import ContestDisplay from "./ContestDisplay";
import AffiliateProgramDisplay from "./AffiliateProgramDisplay";
import DiscoverDisplay from "./DiscoverDisplay";

import scalelupLogo from "assets/img/logo/scalelup.svg";
import coinsIcon from "assets/img/icons/coins-icon.svg";

const Display = styled.div`
  position: absolute;
  top: 30px;
  left: 50%;
  width: 230px;
  height: 500px;

  font-family: "Barlow", sans-serif;

  transform: translateX(-50%);

  background-color: #1f2c39;
`;

const Header = styled.div`
  width: 100%;
  margin: 0;

  position: relative;
  backdrop-filter: blur(6px);
  z-index: 10;
`;

const HeaderContent = styled.div`
  padding: 3px 10px;
  margin: 0 auto;
  max-width: 1600px;

  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LogoWrap = styled.div`
  width: 90px;
`;

const RightPart = styled.div``;

const BalanceBox = styled.div`
  height: 30px;
  padding: 0px 10px;
  min-width: 20px;

  background: ${css.FLAT_BOX_BACKGROUND};
  border-radius: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

const Icon = styled.div`
  width: 10px;
  min-width: 10px;
  height: 10px;

  display: flex;
`;

const HeaderBalance = styled.div`
  font-size: 10px;
  font-weight: 500;
`;

export default ({ display }) => {
  console.log("display", display);

  return (
    <Display>
      <Header>
        <HeaderContent>
          <LogoWrap>
            <img src={scalelupLogo} style={{ width: "100%" }} />
          </LogoWrap>
          <RightPart>
            <BalanceBox>
              <Icon>
                <img src={coinsIcon} style={{ width: "100%" }} />
              </Icon>
              <HeaderBalance>32,607</HeaderBalance>
            </BalanceBox>
          </RightPart>
        </HeaderContent>
      </Header>
      <WalletDisplay display={display === 1} />
      <ContestDisplay display={display === 2} />
      <DiscoverDisplay display={display === 3} />
      <CashBonusDisplay display={display === 4} />
      <AffiliateProgramDisplay display={display === 5} />
    </Display>
  );
};
